import { type ButtonProps } from '@mui/material';
import React, { type CSSProperties } from 'react';

interface props extends Pick<ButtonProps, 'onMouseEnter' | 'onMouseLeave' | 'onClick' | 'disabled' | 'className'> {
  children: React.ReactNode;
  propagateClick?: boolean;
  style?: Pick<
    CSSProperties,
    | 'minHeight'
    | 'fontWeight'
    | 'marginBottom'
    | 'paddingTop'
    | 'padding'
    | 'borderRadius'
    | 'cursor'
    | 'color'
    | 'minWidth'
    | 'justifyContent'
  >;
}

export default function XDButton(props: props) {
  let classNames = ['rounded-md flex items-center py-1 px-3 uppercase'];

  const handleClick = (ev: React.MouseEvent<HTMLButtonElement>) => {
    if (props.propagateClick === false) ev.stopPropagation();
    if (props.disabled) return;
    props.onClick?.(ev);
  };

  if (props.className) {
    classNames.push(props.className);
  }

  if (!props.className?.includes('hover:')) {
    classNames.push('hover:bg-teal hover:text-teal hover:bg-opacity-10 hover:border-teal');
  }

  if (props.disabled) {
    classNames = classNames
      .join(' ')
      .split(' ')
      .filter((e) => !e.includes('hover:'));
  }

  return (
    <button
      className={classNames.join(' ')}
      style={{
        cursor: props.disabled ? 'default' : 'pointer',
        opacity: props.disabled ? 0.4 : 1,
        minHeight: '2.5rem',
        hyphens: 'none',
        ...props.style
      }}
      onClick={handleClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      {props.children}
    </button>
  );
}
